import type { LegalDocument } from './types'
import { privacyNotice } from './privacyNotice'
import { recordingAndDataRetention } from './recordingAndDataRetention'
import { researchAndInsightsConsent } from './researchAndInsightsConsent'

// The order here is the order of the footer links.
export const LEGAL_DOCUMENTS: LegalDocument[] = [
  privacyNotice,
  recordingAndDataRetention,
  researchAndInsightsConsent,
]

export type { LegalDocument, LegalBlock, LegalText, LegalRun } from './types'
